import { useState, useEffect, useContext } from "react";
import { DatePicker, Select } from "antd";
import { openkit } from "../../library/database";
import AHPTimePicker from "../../components/Calendar/AHPTimePicker";
import { AppContext } from "../../context";
import { GUIDE_AVAILABLE_TIME } from "./guideConstants";
import { FIELD_WIDTHS } from "../../config/layoutConfig";
import { searchGuides } from "./searchGuides";

const getAllUniqueValues = (propertyName, objArray) => {
  if (!objArray.length || !propertyName) return;
  let allValues = [];
  for (const element of objArray) {
    for (const property of element[propertyName]) {
      allValues.push(property);
    }
  }
  let uniqueValues = [...new Set(allValues)];
  return uniqueValues;
};

const createSelectOptions = (categories) => {
  const categoriesSelectOptions = categories.map((c) => ({
    label: c,
    value: c,
  }));
  return categoriesSelectOptions;
};

const GuideFilter = ({ products, setProducts }) => {
  const [languages, setLanguages] = useState(null);
  const [types, setTypes] = useState(null);
  const [specializations, setSpecializations] = useState(null);
  const info = useContext(AppContext);

  useEffect(() => {
    const getGuidesFeaturesFn = async () => {
      const guides = await openkit.data.find("c_products", {
        gen_type: "guide",
      });
      if (!guides.length) return;
      // get available languages
      let languages = getAllUniqueValues("gui_languages", guides);
      // translation
      languages = languages.map((lang) => info.t(lang));
      const languagesOptions = createSelectOptions(languages);
      setLanguages(languagesOptions);

      // get available types
      let types = getAllUniqueValues("gui_types", guides);
      // translation
      types = types.map((type) => info.t(type));
      const typesOptions = createSelectOptions(types);
      setTypes(typesOptions);

      // get available specializations
      let specializations = getAllUniqueValues("gui_specializations", guides);
      // translation
      specializations = specializations.map((spec) => info.t(spec));
      const specializationsOptions = createSelectOptions(specializations);
      setSpecializations(specializationsOptions);
    };

    getGuidesFeaturesFn();
  }, []);

  const handleChange = (type, value) => {
    info.setGuide({ ...info.guide, [type]: value });
  };

  useEffect(() => {
    (async () => {
      const store_id = null;
      const guides = await searchGuides(store_id, info);
      setProducts(guides);
    })();
  }, [info.guide]);

  return (
    <div style={{ marginTop: 10 }}>
      <DatePicker
        placeholder={info.t("date")}
        value={info.guide.date}
        onChange={(value) => info.setGuide({ ...info.guide, date: value })}
        allowClear
        style={{ width: FIELD_WIDTHS.M }}
        bordered={false}
      />
      <AHPTimePicker
        type="guide"
        placeholder={info.t("time")}
        availableTime={GUIDE_AVAILABLE_TIME}
        value={info.guide.time}
        // preferredTime={selectedService.preferredTime}
        // setSelectedService={setSelectedService}
      />
      {/* <div>
        <Select
          placeholder="Duração"
          options={guide.durations}
          value={info.guide.duration}
          style={{ width: FIELD_WIDTH }}
          onChange={(value) => handleChange("duration", value)}
          bordered={false}
        ></Select>
      </div> */}
      <Select
        placeholder={info.t("language")}
        options={languages}
        value={info.guide.language}
        onChange={(value, option) => handleChange("language", value, option)}
        allowClear
        style={{
          width: FIELD_WIDTHS.M,
          marginLeft: 10,
        }}
        bordered={false}
      ></Select>
      <Select
        placeholder={info.t("type")}
        options={types}
        value={info.guide.type}
        onChange={(value) => handleChange("type", value)}
        allowClear
        style={{
          width: FIELD_WIDTHS.M,
          marginLeft: 10,
        }}
        bordered={false}
      ></Select>
      <Select
        placeholder={info.t("specialization")}
        options={specializations}
        value={info.guide.specialization}
        onChange={(value) => handleChange("specialization", value)}
        allowClear
        style={{
          width: FIELD_WIDTHS.L,
          marginLeft: 10,
        }}
        bordered={false}
      ></Select>
    </div>
  );
};

export default GuideFilter;
